/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../../constants';
import axios from "axios";
import Select from 'react-select';
import config from '../../../config/config';
import TileComp from '../../ProcureToPayComp/TileComp/TileComp';
import styles from './TransitionFinanceDashboardComp.module.css';
import './TransitionFinanceDashboardComp.css';
import OverallTransitionSummaryCharts from '../OverallTransitionSummaryCharts/OverallTransitionSummaryCharts';
import DashboardSection from '../../DashboardContainer/DashboardSection';
import HorizontalProgressChart from '../HorizontalProgressChart/HorizontalProgressChart';
import ReusableTable from '../../ReusableTable/ReusableTable';

import EntityStatusComparisonChart from '../EntityStatusComparisonChart/EntityStatusComparisonChart';
import TitleWithDetailedClick from '../TitleWithDetailedClick/TitleWithDetailedClick';
import NewInfoIcon from '../../ProcureToPayComp/TileComp/NewInfoIcon';

const overallOptions = [
    { value: 'overall', label: 'Overall summary' },
    { value: 'towerwise', label: 'Towerwise summary' },
];

const { API_BASE_URL } = config;

const TransitionFinanceDashboardComp = () => {

    const { showPopup } = usePopupManager();
    const location = useLocation();
    const initialFilters = location.state || {
        inOutData: [],
        locationData: [],
        subDivisionData: [],
        yearData: [],
        quarterData: [],
    };

    const [filters, setFilters] = useState(initialFilters);
    const [showDashboard, setShowDashboard] = useState(false);
    const [showMainDashboard, setShowMainDashboard] = useState(false);
    const [detailedButtonClick, setDetailedButtonClick] = useState(false);

    const [InOutOptions, setInOutOptions] = useState([]);
    const [LocationOptions, setLocationOptions] = useState([]);
    const [SubDivisionOptions, setSubDivisionOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [quarterOptions, setQuarterOptions] = useState([]);
    const [entityOptions, setEntityOptions] = useState([]);
    const [InOut, setInOut] = useState([]);
    const [Location, setLocation] = useState([]);
    const [SubDivision, setSubDivision] = useState([]);
    const [Year, setYear] = useState([]);
    const [Quarter, setQuarter] = useState([]);
    const [overall, setOverall] = useState([]);
    // const [entity, setEntity] = useState([entityOptions[0]]);
    const [entity, setEntity] = useState([]);
    const [showTowerWise, setShowTowerWise] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedEntityName, setSelectedEntityName] = useState([]);
    const [selectedTowerName, setselectedTowerName] = useState([]);

    const [towerOptions, settowerOptions] = useState([]);
    const [towerselected, settowerselected] = useState([]);

    const [TileData, setTileData] = useState([]);
    const [EntityGraphData, setEntityGraphData] = useState([]);
    const [QuarterWiseGraphData, setQuarterWiseGraphData] = useState([]);
    const [DetailTableData, setDetailTableData] = useState([]);
    const [DetailTableCount, setDetailTableCount] = useState([]);
    const [DetailTableCSV, setDetailTableCSV] = useState([]);
    const [EntityDrillDownData, setEntityDrillDownData] = useState([]);
    const [TowerWiseGraphData, setTowerWiseGraphData] = useState([]);

    const [varinace, setVariance] = useState(0)
    const [totalVaraince, settotalVaraince] = useState(0)
    const [sumOfActualTile, setsumOfActualTile] = useState(0)
    const [projectedFTE, setprojectedFTE] = useState(0)

    const [actualStatusselected, setactualStatusselected] = useState([]);
    const [actualstatusOptions, setactualstatusOptions] = useState([]);

    const [transitionLeadselected, settransitionLeadselected] = useState([]);
    const [transitionLeadOptions, settransitionLeadOptions] = useState([]);

    const [selectedPage, setSelectedPage] = useState();

    const [hasApplied, setHasApplied] = useState(false);
    
    const [startPage, setStartPage] = useState(0);
    const [endPage, setEndPage] = useState(100);

    const itemsPerPage = 100;

    // const tileStyles = {
    //     tileContainer: {
    //     //   width: '155px',
    //       width: '100%',
    //       height: '120px',
    //       background: 'linear-gradient(135deg, rgb(255 0 73 / 93%) 0%, rgb(213, 149, 181) 100%)',
    //       borderRadius: '16px',
    //       border: '1px solid #e11d48', // Changed to match gradient color
    //       display: 'flex',
    //       flexDirection: 'column',
    //       justifyContent: 'space-between',
    //       boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px',
    //       fontFamily: 'Arial, sans-serif',
    //     //   marginTop: '25px',
    //       padding: '8px',
    //       boxSizing: 'border-box',
    //       color: 'white', // Set default text color to white
    //       boxShadow: ' rgba(0, 0, 0, 0.4) 4px 4px 8px'
    //     },
    //     title: {
    //         border:'2px solid white',
    //       display:'inline',
    //       fontSize: '14px',
    //       fontWeight: '600',
    //       color: 'white', // White for better contrast
    //       textAlign: 'center',
    //       marginBottom: '8px',
    //       textShadow: '0 1px 2px rgba(0,0,0,0.2)',
    //       // Adds subtle text shadow for readability
    //     },
    //     infoicon: {
    //         border:'2px soild white',
    //       display:'inline-flex',
    //       flexDirection:'row-reverse'
    //     },
    //     mainValue: {
    //       fontSize: '12px',
    //       fontWeight: '700',
    //       color: 'white', // White for better contrast
    //       textAlign: 'center',
    //       marginBottom: '6px',
    //       textShadow: '0 2px 4px rgba(0,0,0,0.3)'
    //     },
    //     secondaryValue: {
    //       fontSize: '12px',
    //       fontWeight: '700',
    //       color: '#ffffff', // Light yellow for contrast
    //       textAlign: 'center',
    //       marginBottom: '4px',
    //       textShadow: '0 1px 2px rgba(0,0,0,0.2)'
    //     },
    //     thirdValue: {
    //       fontSize: '12px',
    //       color: '#ffffff', // Light gray
    //       fontWeight: '700',
    //       textAlign: 'center',
    //       // opacity: '0.9'
    //     }
    //   };

    const tileStyles = {
        tileContainer: {
          width: '100%',
          height: '120px',
          background: 'linear-gradient(135deg, rgb(255 0 73 / 93%) 0%, rgb(213, 149, 181) 100%)',
          borderRadius: '16px',
          border: '1px solid #e11d48',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '8px',
          boxSizing: 'border-box',
          color: 'white',
          boxShadow: 'rgba(0, 0, 0, 0.4) 4px 4px 8px'
        },
      
        header: {
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          height: '24px'
        },
      
        title: {
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: '14px',
          fontWeight: '600',
          color: 'white',
          textAlign: 'center'
        },
      
        infoicon: {
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer'
        },
      
        mainValue: {
          fontSize: '12px',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '6px'
        },
      
        secondaryValue: {
          fontSize: '12px',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '4px'
        },
      
        thirdValue: {
          fontSize: '12px',
          fontWeight: '700',
          textAlign: 'center'
        }
      };

    const handleInOutChange = (selected) => {
        // setInOut(selected);
        setInOut(selected || []);
        setFilters(prev => ({ ...prev, inOutData: selected }));
    };

    const handleLocationChange = (selected) => {
        // setLocation(selected);
        setLocation(selected || []);
        setFilters(prev => ({ ...prev, locationData: selected }));
    };

    const handleSubDivisionChange = (selected) => {
        // setSubDivision(selected);
        setSubDivision(selected || []);
        setFilters(prev => ({ ...prev, subDivisionData: selected }));
    };

    // const handleYearChange = (selected) => {
    //   // setYear(selected);
    //   setYear(selected || []);
    //   setFilters(prev => ({ ...prev, yearData: selected }));
    // };

    // const handleYearChange = (selected) => {
    //   const updatedYear = selected || [];
    //   setYear(updatedYear);
    //   setFilters(prev => ({ ...prev, yearData: updatedYear }));

    //   if (updatedYear.length === 0) {
    //     setQuarter([]);
    //     setFilters(prev => ({ ...prev, quarterData: [] }));
    //   }
    // };

    const handleYearChange = (selected) => {
        if (!selected) {
            setYear([]);
            setQuarter([]);
            setFilters(prev => ({ ...prev, yearData: [], quarterData: [] }));
            return;
        }
        const updatedYear = [selected];
        setYear(updatedYear);
        setFilters(prev => ({ ...prev, yearData: updatedYear }));
        setQuarter([]);
        setFilters(prev => ({ ...prev, quarterData: [] }));
    };

    const handleQuarterChange = (selected) => {
        // setQuarter(selected);
        setQuarter(selected || []);
        setFilters(prev => ({ ...prev, quarterData: selected }));
    };

    const handleTowerChange = (selected) => {
        const selectedArray = selected || [];
        settowerselected(selected || []);
        setFilters(prev => ({ ...prev, towerData: selected }));
        const selectedtowerNames = selectedArray.map(e => e.label);
        setselectedTowerName(selectedtowerNames.join(', '));
    };

    const handlePageChange = (page) => {
        setHasApplied(true)
        setSelectedPage(page);
        let endPageVal = page * 100
        let startPageVal = endPageVal - 99
    
        setStartPage(startPageVal)
        setEndPage(endPageVal)
        // console.log(`Selected page: ${page}`);
    };

    const handleActualStatusChange = (selected) => {
        // setLocation(selected);
        setactualStatusselected(selected || []);
        setFilters(prev => ({ ...prev, locationData: selected }));
    };

    const handleTransitionLeadChange = (selected) => {
        // setLocation(selected);
        settransitionLeadselected(selected || []);
        setFilters(prev => ({ ...prev, locationData: selected }));
    };

    const fetchInOutOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-in-out`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setInOutOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchLocationOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-location`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setLocationOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchSubDivisionOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-sub-division`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setSubDivisionOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchYearOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-year`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setYearOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchQuerterOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-quarter`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setQuarterOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchEntityOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-entity`, {
                headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
            });
            const data = response.data || [];
            setEntityOptions(data);
            // if (data.length > 0) {
            //   setEntity([data[0]]);
            //   setSelectedEntityName(data[0].label);
            // }
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchTowerOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-tower`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    settowerOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
    };

    const fetchActualstatusOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-Actual-status`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                    setactualstatusOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
      };

      const fetchTransitionLeadOptions = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/transition-transition-lead`, {
                headers: {
                    // Authorization: `Bearer ${token}`,
                    Authorization: 'Basic YWRtaW4xOjEyMw==',
                },
            })
                .then((response) => {
                  settransitionLeadOptions(response.data);
                })
        } catch (error) {
            console.error('Error fetching entity options:', error);
        }
      };

    useEffect(() => {
        fetchInOutOptions();
        fetchLocationOptions();
        fetchSubDivisionOptions();
        fetchYearOptions();
        fetchQuerterOptions();
        fetchEntityOptions();
        fetchTowerOptions();
        fetchActualstatusOptions();
        fetchTransitionLeadOptions();
        // console.log("main page filter check -------------->", filters);
    }, []);

    function calculateVariance(data) {
        const {
          projectedFTE = 0,
          goLiveComplete = 0,
          transitionsInprog = 0,
          inFlight = 0,
          pipeline = 0
        } = data;
    
        const total = goLiveComplete + transitionsInprog + inFlight + pipeline;
    
        // Avoid division by zero
        const divisor = projectedFTE !== 0 ? projectedFTE : 1;
    
        let variancePercent = Number(((projectedFTE - total) / divisor * 100).toFixed(3));
        const totalVaraince = Number((projectedFTE - total).toFixed(3));
    
        // Set minimum variance to 0
        if (variancePercent < 0) {
          variancePercent = 0;
        }
    
        return {
          totalVaraince,
          total
        };
      }

    const handleApply = () => {
        // if (Year.length === 0) {
        //   showPopup({
        //     type: MESSAGE_TYPE.INFORMATION,
        //     contextText: MESSAGE_TYPE.INFORMATION,
        //     info: "Please select a Financial Year before applying filters.",
        //   });
        //   return;
        // }
        // if (InOut?.length > 0 || Location?.length > 0 || SubDivision?.length > 0 || Year?.length > 0 || Quarter?.length > 0) {
            const selectedEntity = entity.map(e => e.value);
            const inoutFilterData = InOut.map(e => e.value);
            const locationFilterData = Location.map(e => e.value);
            const subDivisionFilterData = SubDivision.map(e => e.value);
            const yearFilterData = Year.map(e => e.value);
            const quarterData = Quarter.map(e => e.value);
            const TOWERS = towerselected.map(e => e.value);
            const actualStatus = actualStatusselected.map(e => e.value);
            const transitionLead = transitionLeadselected.map(e => e.value);

        setIsLoading(true);

        const fetchTransitionFirst = async () => {
            try {
                const response = await axios.post(
                    `${API_BASE_URL}/api/transition-Finance-Dashboard`,
                    {
                        selectedInout: inoutFilterData,
                        selectedLocation: locationFilterData,
                        selectedEntity: selectedEntity,
                        selectedSubDiv: subDivisionFilterData,
                        selectedYear: yearFilterData,
                        selectedQuarter: quarterData,
                        selectedTower:TOWERS,
                        selectedActualstatus: actualStatus,
                        selectedTranLead: transitionLead,
                        start: startPage,
                        end: endPage,
                    },
                    {
                        headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' }
                    }
                );

                const data = response.data;
                setTileData(data.FinanceTileData);
                setEntityGraphData(data.FinanceEntityWiseData);
                setQuarterWiseGraphData(data.FinanceQuarterWiseData);
                setDetailTableData(data.FinanceDetailTable.tableData);
                setDetailTableCount(data.FinanceDetailTable.tableCount);
                setDetailTableCSV(data.FinanceDetailTable.tableCSV);
                setEntityDrillDownData(data.FinanceEntityWiseDrilldownData);
                setTowerWiseGraphData(data.FinanceTowerWiseDrillDownData);
                const calculatedVariance = calculateVariance(data.getTransitionStatusData);
                settotalVaraince(calculatedVariance?.totalVaraince);
                setVariance(data.getTransitionStatusData.variance)
                // setsumOfActualTile(calculatedVariance?.total)
                setsumOfActualTile(Number(calculatedVariance?.total || 0).toFixed(2))
                setprojectedFTE(data.getTransitionStatusData.projectedFTE);
            } catch (error) {
                console.error('Error fetching total tiles data:', error);
            }
        };

        Promise.all([
            fetchTransitionFirst(),
        ]).then(() => {
            if (detailedButtonClick === false) {
                setShowDashboard(true);
                setShowMainDashboard(true);
                setDetailedButtonClick(false);
                setIsLoading(false);
              } else {
                setDetailedButtonClick(true);
                setShowMainDashboard(false);
                setShowDashboard(true);
                setIsLoading(false);
              }
        });
        // }
        // else {
        //   showPopup({
        //     type: MESSAGE_TYPE.INFORMATION,
        //     contextText: MESSAGE_TYPE.INFORMATION,
        //     info: "Please select atleast one filter value.",
        //   });
        // }
    };


    const handleReset = () => {
        setInOut([]);
        setLocation([]);
        setSubDivision([]);
        setYear([]);
        setEntity([]);
        setQuarter([]);
        settowerselected([]);
        setSelectedEntityName([]);
        setselectedTowerName([]);
        setactualStatusselected([]);
        settransitionLeadselected([]);
        setHasApplied(false);
        setFilters({
            inOutData: [],
            locationData: [],
            subDivisionData: [],
            yearData: [],
            quarterData: [],
        });
        setShowDashboard(false);
        setShowMainDashboard(false);
        setDetailedButtonClick(false);
    };

    const handleStatus = (val) => {
        setOverall(val);
        // console.log("test clicked ---------->", val.value);
        if (val.value !== 'towerwise') {
            setShowTowerWise(false);
        } else {
            setShowTowerWise(true);
        }
    }

    const handleEntity = (selected) => {
        const selectedArray = selected || [];
        setEntity(selectedArray);
        const selectedEntityNames = selectedArray.map(e => e.label);
        setSelectedEntityName(selectedEntityNames.join(', '));
    };

    useEffect(() => {
        setOverall({ value: 'overall', label: 'Overall summary' });
    }, []);

    const customStylesMultiSelect = {
        control: (provided) => ({
            ...provided,
            minHeight: '40px',
            flexWrap: 'wrap',
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '100px',
            overflowY: 'auto',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            overflow: 'visible',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            overflowX: 'auto',
            whiteSpace: 'nowrap',
        }),
        option: (provided) => ({
            ...provided,
            padding: '8px 12px',
        }),
    };

    const EntityWiseLabel = EntityGraphData.map(i=>i[0]);

    const EntityWisechartData = {
        labels: EntityWiseLabel,
        datasets: [
            {
                label: "Go-Live Completed",
                data: EntityGraphData.map(i=>i[1]),
                backgroundColor: "#4DA1A9",
            },
            {
                label: "Transition in Progress",
                data: EntityGraphData.map(i=>i[2]),
                backgroundColor: "#ffd000",
            },
            {
                label: "Total",
                data: EntityGraphData.map(i=>i[3]),
                type: "line",
                borderColor: "#1976D2",
                backgroundColor: "#1976D2",
                tension: 0.3,
                pointRadius: 5,
            },
        ],
    };

    const QuarterWiseLabel = QuarterWiseGraphData.map(i=>i[0]);

    const QuarterWisechartData = {
        labels: QuarterWiseLabel,
        datasets: [
            {
                label: "Go-Live Completed",
                data: QuarterWiseGraphData.map(i=>i[1]),
                backgroundColor: "#4DA1A9",
            },
            {
                label: "Transition in Progress",
                data: QuarterWiseGraphData.map(i=>i[2]),
                backgroundColor: "#ffd000",
            },
            {
                label: "Total",
                data: QuarterWiseGraphData.map(i=>i[3]),
                type: "line",
                borderColor: "#1976D2",
                backgroundColor: "#1976D2",
                tension: 0.3,
                pointRadius: 5,
            },
        ],
    };

    const columns = [
        { header: "Billing_GO_live_Month", accessor: "billing_go_live_month" },
        { header: "Project_ID", accessor: "project_id" },
        { header: "Billing_Type", accessor: "billing_type" },
        { header: "Tower", accessor: "tower" },
        { header: "Work_Area", accessor: "work_area" },
        { header: "PO_Number", accessor: "po_number" },
        { header: "Employee_Grade", accessor: "employee_grade" },
        { header: "Location", accessor: "location" },
        { header: "Legal_Entity", accessor: "legal_entity" },
        { header: "Sub_Division", accessor: "sub_division" },
        { header: "DOM_EXP", accessor: "dom_exp" },
        { header: "Project_End_Date", accessor: "project_end_date" },
        { header: "Resource_Deployment_Date", accessor: "resource_deployment_date" },
        { header: "Actual_FTE_Nos", accessor: "actual_fte_nos" },
        { header: "Rate_card", accessor: "rate_card" },
        { header: "Billing_Till_MMM_YY_In_lakhs", accessor: "billing_till_mmm_yy_in_lakhs" },
        { header: "Yearly_Billing_Rs_in_Lacs", accessor: "yearly_billing_rs_in_lacs" },
        { header: "Business_Approver_Name", accessor: "business_approver_name" }
    ]

    const [totalRecords, setTotalRecords] = useState(0);
    const [dataLoading, setdataLoading] = useState(false);

    const handleCSVDownload = () => {
    const csvHeader = columns.map(col => col.header).join(',');

    const csvRows = DetailTableCSV.map(row =>
        columns.map(col => {
        const value = row[col.accessor] ?? '';
        return `"${String(value).replace(/"/g, '""')}"`;
        }).join(',')
    );

    const csvContent = [csvHeader, ...csvRows].join('\n');

    const blob = new Blob(["\ufeff" + csvContent], {
        type: 'text/csv;charset=utf-8;',
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Transition_Finance.csv';
    link.click();
    };

    const labelsDetailedEntityWiseChart = EntityDrillDownData.map(i => i[0])

    const entityActualFTEs = {
        label: "Actual FTEs",
        data: EntityDrillDownData.map(i => i[1]),
        backgroundColor: "#1f77b4",
    }
    const entityBudgetedFTEs = {
        label: "Budgeted FTEs",
        data: EntityDrillDownData.map(i => i[2]),
        backgroundColor: "#ff7f0e",
    }

    const towerWiseOverallLabels = TowerWiseGraphData.map(i => i[0]);

    const towerWiseOverallActual = {
        label: "Actual FTE's",
        data: TowerWiseGraphData.map(i => i[1]),
        backgroundColor: "#1f77b4",
    }

    const towerWiseOverallBudgeted = {
        label: "Budgeted FTE's",
        data: TowerWiseGraphData.map(i => i[2]),
        backgroundColor: "#ff7f0e",
    }

    const handleDetailClick = () => {
        setDetailedButtonClick(true);
        setShowMainDashboard(false);
    }

    const handleMainPageClick = () => {
        setDetailedButtonClick(false);
        setShowMainDashboard(true);
    }

    const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
    // const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
    const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
    const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
    const blueGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';
    const varinceGradient = 'linear-gradient(135deg, #EC4899 0%, #d595b5ff 100%)';

    useEffect(() => {
        if (hasApplied) {
          handleApply();
        }
      }, [selectedPage,hasApplied]);

    return (
        <>
            <div className={styles.filter_panel_container}>
                <div className={styles.filter_panel_row}>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>IN/OUT</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={InOut}
                                onChange={handleInOutChange}
                                options={InOutOptions}
                                closeMenuOnSelect={false}
                                isMulti
                                isSearchable={true}
                                placeholder="Select IN/OUT"
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Location</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={Location}
                                onChange={handleLocationChange}
                                options={LocationOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Location"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Legal Entity</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={entity}
                                placeholder={<div className="select-placeholder-text">Select Legal Entity</div>}
                                onChange={handleEntity}
                                options={entityOptions}
                                // isSearchable={false}
                                isMulti
                                isSearchable={true}
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Sub-Division</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={SubDivision}
                                onChange={handleSubDivisionChange}
                                options={SubDivisionOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Sub-Division"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Tower</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={towerselected}
                                onChange={handleTowerChange}
                                options={towerOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Tower"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.filter_panel_row} style={{ paddingTop: "10px" }}>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Financial Year</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={Year}
                                onChange={handleYearChange}
                                options={yearOptions}
                                // isMulti
                                isSearchable={true}
                                placeholder="Select Financial Year"
                                // closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Quarter</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={Quarter}
                                onChange={(selected) => {
                                    if (Year.length === 0) {
                                        showPopup({
                                            type: MESSAGE_TYPE.INFORMATION,
                                            contextText: MESSAGE_TYPE.INFORMATION,
                                            info: "Please select Financial Year first before selecting Quarter.",
                                        });
                                        return;
                                    }
                                    handleQuarterChange(selected);
                                }}
                                options={quarterOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Select Quarter"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                                isDisabled={Year.length === 0}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Actual status</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={actualStatusselected}
                                onChange={handleActualStatusChange}
                                options={actualstatusOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Actual Status"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <label className={styles.filter_label}>Transition Lead</label>
                        <div className={styles.filter_select_wrapper}>
                            <Select
                                value={transitionLeadselected}
                                onChange={handleTransitionLeadChange}
                                options={transitionLeadOptions}
                                isMulti
                                isSearchable={true}
                                placeholder="Transition Lead"
                                closeMenuOnSelect={false}
                                styles={customStylesMultiSelect}
                            />
                        </div>
                    </div>
                    <div className={styles.filter_panel_col}>
                        <div className={styles.filter_select_wrapper}>
                            <div className="filter-panel-col">
                                <button onClick={handleApply} className="btn apply-btn">
                                    Apply
                                </button>
                                <button onClick={handleReset} className="btn reset-btn">
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        zIndex: 9999,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary mb-3" role="status"></div>
                        <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>

                    </div>
                </div>
            )}
            {showDashboard && (
                <>
                    <div>
                        <div className="row mb-3" >
                            <div className="col-md-3">
                                {/* <TileComp
                                    title="Total Targeted FTEs"
                                    number={TileData.tt_FTE}
                                    gradient={paidOnTimeGradient}
                                    popupContent="This Metric Mannual CSV Data."
                                    showDownload={false}
                                /> */}
                            <TileComp
                                title="Projected FTEs"
                                number={projectedFTE}
                                gradient={paidOnTimeGradient}
                                popupContent="This Metric Mannual CSV Data."
                                showDownload={false}
                            />
                            </div>
                            <div className="col-md-3">
                            <TileComp
                                title="Go-Live Completed"
                                number={TileData.go_live}
                                gradient={blueGradient}
                                popupContent="This Metric Mannual CSV Data."
                                showDownload={false}
                            />
                            </div>
                            <div className="col-md-3">
                            <TileComp
                                title="Transition in Progress"
                                number={TileData.in_process}
                                gradient={indigoGradient}
                                popupContent="This Metric Mannual CSV Data."
                                showDownload={false}
                            />
                            </div>
                            <div className="col-md-3">
                                {/* <TileComp
                                    title="Completion %"
                                    number={`${TileData.completion} %`}
                                    gradient={varinceGradient}
                                    popupContent="This Metric Mannual CSV Data."
                                    showDownload={false}
                                /> */}
                                <div style={tileStyles.tileContainer}>
                                {/* <div style={tileStyles.infoicon}>
                                    <NewInfoIcon popupContent="Mannual CSV Data" />
                                </div>
                                <div style={tileStyles.title}>Variance</div> */}
                                <div style={tileStyles.header}>
                                    <div style={tileStyles.title}>Variance</div>
                                    <div style={tileStyles.infoicon}>
                                        <NewInfoIcon popupContent="Mannual CSV Data" />
                                    </div>
                                </div>
                                <div>
                                    <div style={tileStyles.mainValue}>Variance {totalVaraince}</div>
                                    <div style={tileStyles.secondaryValue}>Variance Per {varinace}%</div>
                                    <div style={tileStyles.thirdValue}>Actual Total {sumOfActualTile}</div>
                                </div>
                                </div>
                            </div>
                        </div>
                        {showMainDashboard && (
                            <div>
                                <TitleWithDetailedClick
                                    // title="Finance Summary"
                                    title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} Finance Summary` : " Overall Finance Summary"}
                                    handleDetailClick={handleDetailClick}
                                />
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-3">
                                        <DashboardSection title="Sub Division Wise Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                                            <OverallTransitionSummaryCharts
                                                labels={EntityWiseLabel}
                                                chartData={EntityWisechartData}
                                                showTable={false}
                                            />
                                        </DashboardSection>
                                    </div>
                                    <div className="col-12 col-lg-6 mb-3">
                                        <DashboardSection title="Quarter Wise Finance Status " disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                                            <div>
                                                {/* <HorizontalProgressChart data={chartDataProgress} /> */}
                                                {/* <HorizontalProgressChart
                                                    labels={labelsFTEWiseChart}
                                                    actualFTEs={actualFTEs}
                                                    budgetedFTEs={budgetedFTEs}
                                                    heightValues={250}
                                                /> */}
                                                <OverallTransitionSummaryCharts
                                                labels={QuarterWiseLabel}
                                                chartData={QuarterWisechartData}
                                                showTable={false}
                                            />
                                            </div>
                                        </DashboardSection>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <DashboardSection title="Finance Status Details" disableDetailView={true} detailPath="" infoIcondata="Mannual CSV Data">
                                            <ReusableTable
                                                data={DetailTableData} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={DetailTableCount} handleCSVDownload={handleCSVDownload} currentPage={selectedPage ? selectedPage - 1 : 0} 
                                            />
                                        </DashboardSection>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* after click on detailed page */}
                        {detailedButtonClick && (
                            <div>
                                <TitleWithDetailedClick
                                    // title="Detailed View"
                                    title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} Detailed View` : "Detailed View"}
                                    handleBackClick={handleMainPageClick}
                                    showBackButton={true}
                                    showDetailedButton={false}
                                />
                                <div className="row">
                                    <div className="col-12 col-lg-6 mb-3">
                                        <DashboardSection title="Entity wise Drilldown" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                                            <EntityStatusComparisonChart
                                                title={selectedEntityName}
                                                labels={labelsDetailedEntityWiseChart}
                                                actualFTEs={entityActualFTEs}
                                                budgetedFTEs={entityBudgetedFTEs}
                                                heightValues="380px"
                                            />
                                        </DashboardSection>
                                    </div>
                                    <div className="col-12 col-lg-6 mb-3">
                                        <DashboardSection title="Tower Wise Overall Status" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters} infoIcondata="Mannual CSV Data">
                                            <div>
                                                {/* <HorizontalProgressChart data={chartDataProgress} /> */}
                                                <HorizontalProgressChart
                                                    labels={towerWiseOverallLabels}
                                                    actualFTEs={towerWiseOverallActual}
                                                    budgetedFTEs={towerWiseOverallBudgeted}
                                                    heightValues={250}
                                                />
                                            </div>
                                        </DashboardSection>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-12 mb-3">
                                        <DashboardSection title="Finance Status Details" disableDetailView={true} detailPath="" infoIcondata="Mannual CSV Data">
                                            <ReusableTable
                                                data={DetailTableData} columns={columns} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={DetailTableCount} handleCSVDownload={handleCSVDownload} currentPage={selectedPage ? selectedPage - 1 : 0} 
                                            />
                                        </DashboardSection>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default TransitionFinanceDashboardComp;
